module.exports = __webpack_public_path__ + "8b451702.svg";